<div id="selection-container-{{id}}" class="selection-container-div" [class.hasSelection]="has_selection">

  <div id="selection-{{id}}" class="selection">



  </div>

  <div class="meta" id="selection-meta">


    <div class="size-row" id="selection-size-row">
      @if (width !== -1) {
      <span>{{width}} x {{height}} </span>
      }
    </div>

  </div>

</div>

<div id="copied-container-{{id}}" class="copy-container-div" [class.hasCopy]="has_copy">
  <div id="copied-pattern-{{id}}" class="copy">
  </div>
</div>